import { useRef, useCallback } from 'react';

/**
 * Hook for Month-specific interaction logic.
 */
export function useMonthInteractions({
    interaction,
    setInteraction
}) {
    const monthDragMetaRef = useRef(null);

    const handleMonthDragStart = useCallback((assignment, originDay) => {
        monthDragMetaRef.current = {
            assignment,
            originDay: originDay ? new Date(originDay).toISOString() : assignment?.start_datetime
        };
    }, []);

    const handleMonthDragEnd = useCallback(() => {
        monthDragMetaRef.current = null;
    }, []);

    const getMonthDragMeta = useCallback(() => {
        return monthDragMetaRef.current;
    }, []);

    return {
        handleMonthDragStart,
        handleMonthDragEnd,
        getMonthDragMeta
    };
}
